@if (showShell) {
  <div class="d-flex flex-column app-shell">
    <app-topnav
      [companyInfo]="authService.userInfo?.userCompanySettings?.companyDetails ?? null"
      [profileInfo]="authService.userInfo?.userCompanySettings?.profile ?? null"
    ></app-topnav>

    <div class="d-flex flex-grow-1 overflow-hidden">
      <!-- Sidenav column -->
      @if (isLoggedIn) {
        <div
          class="hr-sidebar-wrapper p-0"
          [ngClass]="{ 'sidebar-closed': !isExpanded }"
          [style.width.px]="isExpanded ? 220 : 56"
        >
          <app-sidenav [isExpanded]="isExpanded" (toggleSidebar)="toggleSidebar()"></app-sidenav>
        </div>
      }

      <div class="content-container flex-grow-1 overflow-auto">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
} @else {
  <div class="no-shell-container">
    <router-outlet></router-outlet>
  </div>
}

<app-toaster style="position: relative; z-index: 10000"></app-toaster>

<p-confirmdialog position="top"></p-confirmdialog>
